
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSandbanks as ObiChartSandbanksElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-sandbanks.js';
 
 
 

 
 export const ObiChartSandbanks = createComponent({
   react: React,
   tagName: 'obi-chart-sandbanks',
   elementClass: ObiChartSandbanksElement,
   events: {
     
   }
  });
 
 